// CSS phone mockup frame — makes screenshots look like a finished product
export const PhoneMockup = ({ src, alt, testid, large = false }) => (
  <div data-testid={testid} className={`hi-phone mx-auto ${large ? "hi-phone-lg" : ""}`}>
    <div className="hi-phone-notch" />
    <div className="hi-phone-screen">
      {src ? (
        <img src={src} alt={alt} loading="lazy" className="w-full h-full object-cover object-top" />
      ) : (
        <div className="w-full h-full grid place-items-center bg-[#0c1626] text-white/40 hi-body text-xs">
          Preview loading…
        </div>
      )}
    </div>
  </div>
);

export default PhoneMockup;
